export default __webpack_public_path__ + "static/media/glass_ferrule.f43d858f.JPG";